<template>
  <div id="introduction">
    <div class="row">
      <div class="col-12 mb-5">
        <div class="card bg-gradient-default shadow">
          <div class="card-header bg-transparent">
            <div class="row align-items-center">
              <div class="col">
                <h2 class="text-white mb-0">Major Accomplishments this Year</h2>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div v-for="accomplishment in accomplishments" class="grid-item-container">
              <div @click="showAccomplishmentDetail(accomplishment)" class="grid-item clickable">
                <div v-html="accomplishment.icon" class="grid-icon">
                </div><!-- /.grid-icon -->
                <div class="grid-title">
                  {{ accomplishment.title }}
                </div><!-- /.grid-title -->
              </div><!-- /.grid-item -->
            </div><!-- /.grid-item-container -->
          </div>
        </div>
      </div>
    </div>

    <!-- ACCOMPLISHMENT DETAIL MODAL -->
    <transition name="fade">
      <div v-if="showAccomplishmentDetailModal == true" class="grid-modal-container">
        <div class="grid-modal">
          <a @click="closeAccomplishmentModal()" class="close clickable"><i class="far fa-times"></i></a>
          <div v-html="accomplishmentDetailed.icon" class="grid-modal-icon">
          </div><!-- /.grid-modal-icon -->
          <div class="grid-modal-title">
            {{ accomplishmentDetailed.title }}
          </div><!-- /.grid-modal-title -->
          <div class="grid-modal-description">
            {{ accomplishmentDetailed.description }}
          </div><!-- grid-modal-description -->
          <div v-if="accomplishmentDetailed.map" class="modal-map">
            <iframe width="100%" height="450px" :src="accomplishmentDetailed.mapUrl" />
          </div>
        </div><!-- /.grid-modal-container -->
      </div><!-- /.grid-modal-container -->
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      accomplishments: [
        {
          icon: '<i class="fas fa-home"></i>',
          title: 'SALES 4 REHAB Program',
          description: '26 Properties were sold, representing $1,288,407 in assessment value returned to the county tax rolls, and $1,286,000 in private reinvestment in our neighborhoods via housing rehabilitation.'
        },
        {
          icon: '<i class="fas fa-exclamation-triangle"></i>',
          title: 'DEMOLITION Program',
          description: '25 Properties were demolished, representing $1,068,000 in state funding (non-tax dollars) investment in blight remediation and neighborhood health and safety.',
          map: true,
          mapUrl: 'https://labs.orbitist.com/cclbc-2018-annual-report/maps/demos/#10/42.3142/-79.3705'
        },
        {
          icon: '<i class="fas fa-user-friends"></i>',
          title: 'NEIGHBORS 4 NEIGHBORHOODS Program',
          description: '4 Properties, 2 in Dunkirk and 2 in Jamestown, renovated to high quality standards, creating 7 affordable rentals that are beautiful, lead and asbestos-free with responsible land lords committed to keeping them up to standard and at affordable rent levels for the next 20 years. This program represents a state (non-tax dollars) investment of over $450,000 in affordable housing in our communities.'
        },
        {
          icon: '<i class="fas fa-history"></i>',
          title: 'OPERATIONS',
          description: 'Shortened the inventory cycle for our rehab properties from acquisition to re-sale, which in turn reduces our holding costs as a percentage of overall expense.'
        },
        {
          icon: '<i class="fas fa-laptop-code"></i>',
          title: 'New Website',
          description: 'Upgraded our web site to provide more program visibility and transparency to our program and policies, and increasing our on line traffic. In 2018 the website served 31,545 pages to 4,423 unique users. 85.6% of those users were new to the site. By far the most visited area of the site was our properties listings with 23.4% of all pageviews hapenning within the properties listings database.'
        },
        {
          icon: '<i class="fas fa-dollar-sign"></i>',
          title: '$2 Million Dollar Grant',
          description: 'We secured a $2 million grant from the NYS Attorney General’s office, administered through Enterprise Community Partners, to support our program operations and expansion into 2020.'
        }
      ],
      showAccomplishmentDetailModal: false,
      accomplishmentDetailed: {}
    }
  },
  methods: {
    closeAccomplishmentModal() {
      this.showAccomplishmentDetailModal = false
    },
    showAccomplishmentDetail(accomplishment) {
      this.accomplishmentDetailed = accomplishment
      this.showAccomplishmentDetailModal = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Work.vue